export function copyMatchingFields(source, target, excludeKeys) {
    for (const key in source) {
        if (excludeKeys != null && excludeKeys.includes(key)) {
            continue;
        }
        if (source.hasOwnProperty(key) && target.hasOwnProperty(key)) {
            target[key] = source[key];
        }
    }
}

//** */
export function copyMatchingFieldsIter(source, target, excludeKeys) {
    for (const key in source) {
        if (excludeKeys != null && excludeKeys.includes(key)) {
            continue;
        }
        if (source != null && target != null && source.hasOwnProperty(key) && target.hasOwnProperty(key)) {
            if(isObject(target[key])){
                copyMatchingFieldsIter(source[key], target[key], excludeKeys)
            }else{
            target[key] = source[key];
            }
        }
    }
}

export function isObject(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
  }